import React from "react";
import "./Section1.css";

const Section1 = () => {
  return (
    <section className="section1-hdt">
      <div className="section1-container-hdt">
        <div className="section1-grid-hdt">
          <div className="section1-gallery-hdt">
            <div className="img-card-hdt img-large-left-hdt">
              <img
                src="/hut.webp"
                alt="Destination Venice"
              />
            </div>

            <div className="img-card-hdt img-top-right-hdt">
              <img
                src="/images/teal.jpg"
                alt="Beach destination"
              />
            </div>

            <div className="img-card-hdt img-bottom-center-hdt">
              <img
                src="/images/ordinary.jpg"
                alt="Hot air balloons"
              />
            </div>
          </div>

          <div className="section1-content-hdt">
            <div className="section1-tag-hdt">
              <span>Qui Sommes nous?</span>
              <span className="section1-tag-line-hdt"></span>
            </div>

            <h2 className="section1-title-hdt">
              Une Sélection
              <br />
              De Produits Américains
              <br />
              Rien Que Pour Vous
            </h2>

            <p className="section1-text-hdt">
              Découvrez vos produits américains préférés dans notre supermarché.
              Nous vous proposons une large sélection de marques et de saveurs
              authentiques, avec les meilleures nouveautés chaque semaine.
            </p>

            <div className="stats-row-hdt">
              <div className="stat-box-hdt">
                <h3>10 000+</h3>
                <p>Produits</p>
              </div>

              <div className="stat-box-hdt">
                <h3>100+</h3>
                <p>Marques</p>
              </div>

              <div className="stat-box-hdt">
                <h3>10+</h3>
                <p>Ans Experiences</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section1;